<template>
  <div :class="'alert ' + classname">
    <strong v-show="title">{{ $t(title) }}</strong>
    {{ $t(body) }}
  </div>
</template>

<script>
  export default {
    props: ['classname', 'title', 'body']
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/Notification.vue